import { AbsolutePath } from "@kform/core";

import { useFormContext } from "./useFormContext";

/**
 * Hook providing access to the current path within the context of a form.
 * @throws {NoFormContextError} When no form is in context.
 * @returns The current path within the context of a form.
 */
export function useCurrentPath(): AbsolutePath {
  return useFormContext().currentPath;
}
